import React from 'react';
import ReactDOM from 'react-dom';
import './polyfills'
import ImageProofing from './ImageProofing';
import DocumentProofing from './DocumentProofing';
import VideoProofing from './VideoProofing';
import CustomWorkflow from './CustomWorkflow';
import Boards from './Boards';
import Report from './Report';
import GanttChart from './GanttChart';
import RequestForms from './RequestForms';
import Calendar from './Calendar';
import MobileWrapper from './Components/MobileWrapper';
import './styles/index.css';


const elementIdPrefix = 'interactive-screenshot-';
const components = {
    'custom-workflow': CustomWorkflow,
    'boards': Boards,
    'image-proofing': ImageProofing,
    'video-proofing': VideoProofing,
    'document-proofing': DocumentProofing,
    'report': Report,
    'gantt-chart': GanttChart,
    'calendar': Calendar,
    'request-forms': RequestForms
};

const getPropsForScreenshot = (key) => {
    if(!key || !window.interactiveScreeshotOptions || !window.interactiveScreeshotOptions.props) {
        return {}
    }

    return window.interactiveScreeshotOptions.props[key] || {}
}

let keys = Object.keys(components);

renderScreenshots(true);

// TODO: refactor! Match with gdpr manager!
function renderScreenshots(isGif = false) {
    for(let i = 0; i < keys.length; i++) {
        let element = document.getElementById(elementIdPrefix + keys[i]);

        if(element) {
            const name = keys[i];
            const forceMobileWidth = element.getAttribute('data-force-mobile-width')

            ReactDOM.render(
                <MobileWrapper name={name} isGif={isGif} forceMobileWidth={forceMobileWidth}>
                    {React.createElement(components[name], { ...getPropsForScreenshot(name) })}
                </MobileWrapper>,
                element
            );
        }
    }
}
